import { render } from "./Indecision.vue?vue&type=template&id=8cc25942&scoped=true"
import script from "./Indecision.vue?vue&type=script&lang=js"
export * from "./Indecision.vue?vue&type=script&lang=js"

import "./Indecision.vue?vue&type=style&index=0&id=8cc25942&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8cc25942"

export default script